<script>
	import superagent from 'superagent';
	const Api = 'http://app-api.royalbrides.net';

	let message = {};
	let sent = false;
	let form;

	function onSendMessage(e) {
		e.preventDefault();
		superagent
			.post(Api + '/send_message')
			.send({ ...message })
			.end((err, res) => {
				if(err === null && res) {
					sent = true;
					form.reset();
				} 
			})
	};

	function onChange(e) {
		message[e.target.name] = e.target.value;
	};
</script>

<style>
	html,
body {
  position: relative;
  width: 100%;
  height: 100%;
}

body {
  color: #333;
  margin: 0;
  padding: 8px;
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
}

a {
  color: rgb(0, 100, 200);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

a:visited {
  color: rgb(0, 80, 160);
}

label {
  display: block;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  padding: 0.4em;
  margin: 0 0 0.5em 0;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 2px;
}

input:disabled {
  color: #ccc;
}

input[type="range"] {
  height: 0;
}

button {
  color: #333;
  background-color: #f4f4f4;
  outline: none;
}

button:active {
  background-color: #ddd;
}

button:focus {
  border-color: #666;
}

.container {
  width: 500px;
  display: block;
  margin: 1rem auto;
}
@media (max-width: 768px) {
  .container {
    width: 95%;
    display: block;
    margin: 2rem auto;
  }
}
.header img {
  display: block;
  margin: 0 auto;
  max-height: 3rem;
}
.form-container {
  display: block;
  margin-top: 2rem;
}
.form-container .alert {
  color: mediumseagreen;
  display: block;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  border-radius: 2px;
  background-color: rgba(60, 179, 113, 0.1);
  border: 1px solid rgba(60, 179, 113, 0.25);
}
.form-container .alert p {
  margin: 0;
}
.form-container input,
.form-container textarea,
.form-container button {
  border-color: #eaeaea;
  padding: 0.75rem;
  -webkit-appearance: none;
  outline: 0;
  width: 100%;
  display: block;
  border-radius: 2px;
  margin-bottom: 0.5rem;
}
.form-container input:focus,
.form-container textarea:focus,
.form-container button:focus {
  border-color: #1a1a1a;
}
.form-container textarea {
  resize: vertical;
}
.form-container button {
  color: white;
  background-color: #1a1a1a;
  border: 0;
}
.footer {
  text-align: center;
}
.footer p {
  font-size: 0.8rem;
  color: gray;
}

</style>

<div class="container">
	<div class="header">
		<img src="logo.png" alt="Logo" />
	</div>
	<div class="form-container">
		{#if sent}
			<div class="alert">
				<p>Your message has been sent!</p>
			</div>
		{/if}
		<form bind:this={form} on:submit={onSendMessage} autocomplete="off">
			<input on:input={onChange} name="name" type="text" placeholder="Name" required />
			<input on:input={onChange} name="email" type="email" placeholder="E-mail" required />
			<textarea on:input={onChange} name="message" cols="35" rows="5" placeholder="Message" required />
			<button>Send message</button>
		</form>
	</div>
	<div class="footer">
		<p>All rights reserved. &copy; 2019 Royal Brides</p>
	</div>
</div>